'use client'

import type { TextBlockFieldsFragment } from '@/graphql/types'
import { parseExperiences } from '@/helpers/experiences'
import {
  wrapExperience,
  type BaselineMapper,
  type ExperienceConfiguration,
  Reference,
} from '@ccpgames/eve-web-contentful'
import { createExperienceAwareEntry } from '@/components/templates/dynamic/experienceEntry'
import { TextBlock } from './TextBlock'

const mapTextBlockBaseline: BaselineMapper<TextBlockFieldsFragment, TextBlockFieldsFragment & { id: string }> = (
  entry,
) => {
  const mapped = { id: entry.sys.id, ...entry }
  return mapped
}

const parseTextBlockExperiences = (
  entry: TextBlockFieldsFragment | undefined,
): ExperienceConfiguration<Reference>[] => {
  const experiences = parseExperiences<TextBlockFieldsFragment>(entry)
  return experiences
}

const TextBlockWithExperience = wrapExperience<TextBlockFieldsFragment, TextBlockFieldsFragment & { id: string }>(
  (baseline) => {
    return <TextBlock entry={baseline} />
  },
  mapTextBlockBaseline,
  parseTextBlockExperiences,
)

export function TextBlockExperience({ entry }: { entry: TextBlockFieldsFragment }) {
  return <TextBlockWithExperience entry={entry} />
}

export const TextBlockEntry = createExperienceAwareEntry<TextBlockFieldsFragment>(TextBlock, TextBlockExperience)
